<template>
  <label v-if="label" class="form-label" :for="'amount-' + id">
    {{ label }}
  </label>
  <select
    :id="'amount-' + id"
    class="form-select pr-8"
    v-model="form.amount"
    :disabled="disabled || form.processing"
    @change="submit"
  >
    <option v-for="n in amount" :value="n" :key="n">
      {{ n }}
    </option>
  </select>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3/dist';
import { computed, watch } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  amount: {
    type: [Number, String],
    required: true,
  },
  disabled: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
});

const amount = computed(() =>
  Math.max(props.amount + 1, 10)
);

const form = useForm({
  amount: props.amount,
});

function submit() {
  form.put(route('cart.lines.update-amount', [props.id]), {
    preserveScroll: true
  });
}

watch(() => props.amount, amount => {
  form.amount = amount;
});

</script>
